import { Paper, Typography, TextField, Autocomplete, Button, IconButton, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import forceAbilities from '../data/forceAbilities.json'
import { blankMentorEntry, blankMentorDiscount, isBlankMentorEntry } from '../Util/BlankItems';
import { numericInput } from '../Util/MentorData';

const MentorEdit = ({ editedItem, index, appFiles, setAppFiles }) => {

    const handleEdit = (newItem) => {
        let newFiles = { ...appFiles };
        let newCat = newItem;
        newFiles["mentors"] = JSON.stringify(newCat);
        setAppFiles(newFiles);
        localStorage.setItem('appFiles', JSON.stringify(newFiles));
    };

    const addHistory = (section) => handleEdit({
        ...editedItem,
        MentorHistory: {
            ...editedItem.MentorHistory,
            [section]: [...(editedItem.MentorHistory?.[section] || []), blankMentorEntry(section)],
        },
    });

    const addEntry = (section) => handleEdit({
        ...editedItem,
        [section]: [...(editedItem[section] || []), blankMentorEntry(section)],
    });

    const confirmRemove = (section, entry, name) => isBlankMentorEntry(section, entry)
        || window.confirm(`Remove ${name || "this entry"}? Characters that already picked it keep their copy.`);

    const removeHistory = (section, idx, name) => {
        const entries = editedItem.MentorHistory[section];
        if (!confirmRemove(section, entries[idx], name)) { return; }
        handleEdit({
            ...editedItem,
            MentorHistory: { ...editedItem.MentorHistory, [section]: entries.filter((_, i) => i !== idx) },
        });
    };

    const removeEntry = (section, idx, name) => {
        const entries = editedItem[section];
        if (!confirmRemove(section, entries[idx], name)) { return; }
        handleEdit({ ...editedItem, [section]: entries.filter((_, i) => i !== idx) });
    };

    const removeButton = (label, onClick) => (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }} className="no-print">
            <IconButton size="small" aria-label={label} onClick={onClick}>
                <CloseIcon />
            </IconButton>
        </Box>
    );

    const updateTradition = (idx, part, changes) => {
        let newTraditions = [...editedItem.MentorForceTraditions];
        newTraditions[idx] = { ...newTraditions[idx], [part]: { ...newTraditions[idx][part], ...changes } };
        handleEdit({ ...editedItem, MentorForceTraditions: newTraditions });
    };

    const addButton = (label, onClick) => (
        <Button className="no-print" onClick={onClick}>{label}</Button>
    );

    return (
        <>
            <Typography>{index}</Typography>

            {index === "Mentor History" && (
                <>
                    <Typography>Training:</Typography>
                    {(editedItem.MentorHistory?.Training || []).map((train, idx) => (
                        <Paper variant="outlined" sx={{ padding: "10px" }} key={idx}>
                            {removeButton("Remove entry", () => removeHistory("Training", idx, train.Title))}
                            <p />
                            <TextField
                                label="Title"
                                value={train.Title}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorHistory.Training[idx].Title = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Description"
                                fullWidth
                                value={train.Description}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorHistory.Training[idx].Description = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                        </Paper>
                    ))}
                    {addButton("Add Training", () => addHistory("Training"))}

                    <Typography>The Clone Wars</Typography>
                    {(editedItem.MentorHistory?.TheCloneWars || []).map((tcw, idx) => (
                        <Paper variant="outlined" sx={{ padding: "10px" }} key={idx}>
                            {removeButton("Remove entry", () => removeHistory("TheCloneWars", idx, tcw.Title))}
                            <p />
                            <TextField
                                label="Title"
                                value={tcw.Title}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorHistory.TheCloneWars[idx].Title = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Description"
                                fullWidth
                                value={tcw.Description}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorHistory.TheCloneWars[idx].Description = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                        </Paper>
                    ))}
                    {addButton("Add Clone Wars History", () => addHistory("TheCloneWars"))}

                    <Typography>Surviving the Purge</Typography>
                    {(editedItem.MentorHistory?.SurvivingThePurge || []).map((stp, idx) => (
                        <Paper variant="outlined" sx={{ padding: "10px" }} key={idx}>
                            {removeButton("Remove entry", () => removeHistory("SurvivingThePurge", idx, stp.Title))}
                            <p />
                            <TextField
                                label="Title"
                                value={stp.Title}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorHistory.SurvivingThePurge[idx].Title = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Description"
                                fullWidth
                                value={stp.Description}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorHistory.SurvivingThePurge[idx].Description = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                        </Paper>
                    ))}
                    {addButton("Add Purge History", () => addHistory("SurvivingThePurge"))}
                </>
            )}

            {index === "Mentor Personality" && (
                <>
                    {(editedItem.MentorPersonality || []).map((personality, idx) => (
                        <Paper variant="outlined" sx={{ padding: "10px" }} key={idx}>
                            {removeButton("Remove entry", () => removeEntry("MentorPersonality", idx, personality.Style))}
                            <p />
                            <TextField
                                label="Style"
                                value={personality.Style}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorPersonality[idx].Style = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Details"
                                fullWidth
                                value={personality.Details}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorPersonality[idx].Details = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                        </Paper>
                    ))}
                    {addButton("Add Personality", () => addEntry("MentorPersonality"))}
                </>
            )}

            {index === "Mentor Complications" && (
                <>
                    {(editedItem.MentorComplications || []).map((complication, idx) => (
                        <Paper variant="outlined" sx={{ padding: "10px" }} key={idx}>
                            {removeButton("Remove entry", () => removeEntry("MentorComplications", idx, complication.Complication))}
                            <p />
                            <TextField
                                label="Complication"
                                value={complication.Complication}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorComplications[idx].Complication = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Details"
                                fullWidth
                                value={complication.Details}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorComplications[idx].Details = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                        </Paper>
                    ))}
                    {addButton("Add Complication", () => addEntry("MentorComplications"))}
                </>
            )}

            {index === "Mentor Force Traditions" && (
                <>
                    {(editedItem.MentorForceTraditions || []).map((tradition, idx) => (
                        <Paper variant="outlined" sx={{ padding: "10px" }} key={idx}>
                            {removeButton("Remove entry", () => removeEntry("MentorForceTraditions", idx, tradition.Tradition))}
                            <p />
                            <TextField
                                label="Tradition"
                                value={tradition.Tradition}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorForceTraditions[idx].Tradition = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Description"
                                fullWidth
                                value={tradition.Description}
                                onChange={(e) => {
                                    let newMentors = { ...editedItem }
                                    newMentors.MentorForceTraditions[idx].Description = e.target.value
                                    handleEdit(newMentors)
                                }}
                            />
                            <p />
                            <TextField
                                label="Benefit"
                                fullWidth
                                value={tradition.Benefit?.Description || ""}
                                onChange={(e) => updateTradition(idx, "Benefit", { Description: e.target.value })}
                            />
                            <p />
                            <Typography>Discounts:</Typography>
                            <p />
                            {(tradition.Benefit?.Discounts || []).map((discount, dI) => (<>
                                <p />
                                <Autocomplete
                                    value={forceAbilities.find((ability) => ability.Key === discount.Power) || null}
                                    onChange={(event, newValue) => {
                                        let newMentors = { ...editedItem };
                                        newMentors.MentorForceTraditions[idx].Benefit.Discounts[dI].Power = newValue ? newValue.Key : "";
                                        handleEdit(newMentors);
                                    }}
                                    options={forceAbilities.sort((a, b) => (a.Power + a.Name).localeCompare(b.Power + b.Name))}
                                    getOptionLabel={(option) => option.Power + " " + option.Name}
                                    renderInput={(params) => <TextField {...params} label="Power" />}
                                    sx={{ maxWidth: "500px" }}
                                />

                                <p />
                                <TextField
                                    value={discount.Discount}
                                    onChange={(event) => {
                                        if (!isNaN(event.target.value)) {
                                            let newMentors = { ...editedItem }
                                            newMentors.MentorForceTraditions[idx].Benefit.Discounts[dI].Discount = numericInput(event.target.value)
                                            handleEdit(newMentors);
                                        }
                                    }}
                                />
                                {removeButton("Remove discount", () => updateTradition(idx, "Benefit", {
                                    Discounts: tradition.Benefit.Discounts.filter((_, i) => i !== dI),
                                }))}
                                <p />
                            </>))}
                            {addButton("Add Discount", () => updateTradition(idx, "Benefit", {
                                Discounts: [...(tradition.Benefit?.Discounts || []), blankMentorDiscount()],
                            }))}
                            <p />
                            <TextField
                                label="Drawback"
                                fullWidth
                                value={tradition.Drawback?.Description || ""}
                                onChange={(e) => updateTradition(idx, "Drawback", { Description: e.target.value })}
                            />
                            <p />
                            <TextField
                                label="Remove Drawback Cost"
                                value={tradition.Drawback?.Cost ?? ""}
                                onChange={(e) => {
                                    if (!isNaN(e.target.value)) {
                                        updateTradition(idx, "Drawback", { Cost: numericInput(e.target.value) })
                                    }
                                }}
                            />
                            <p />
                        </Paper>
                    ))}
                    {addButton("Add Tradition", () => addEntry("MentorForceTraditions"))}
                </>
            )}
        </>
    )
}

export default MentorEdit;
